import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import React from 'react'
import { useEvent } from 'effector-react/compat'
import { $historySuggestion, clearHistorySuggestion, deleteHistorySuggestion } from 'src/features/suggestions/history'
import { useList } from 'effector-react'
import * as S from './desktop.styled'
import Cross from '@components/Icons/Cross'
import ButtonTransparent from '@shared/ButtonTransparent/ButtonTransparent'
import { RowDesktop } from 'src/shared/ui/templates/row-desktop'

const ContainerEmpty = styled.div`
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const EmptyMessage = styled.span`
    color: ${ThemeColors.getGrayColor(0.4)};
`

export function HistoryBlock({
    selectHandler
}: {
    selectHandler: (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => void
}) {
    const clear = useEvent(clearHistorySuggestion)
    const deleteHistory = useEvent(deleteHistorySuggestion)
    const deleteHandler = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        e.stopPropagation()
        const id = (e.currentTarget as HTMLDivElement)?.getAttribute('data-history-id')
        if (id === null) throw new Error('Error on delete suggestion id not found')
        deleteHistory(id)
    }
    const history = useList($historySuggestion, {
        fn: (item) => (
            <S.RowContainer>
                <RowDesktop
                    onClick={selectHandler}
                    dataId={item.id}
                    title={item.title}
                    description={item.suggestionTypeTitle}
                />
                <S.ButtonClose onClick={deleteHandler} data-history-id={item.id}>
                    <Cross />
                </S.ButtonClose>
            </S.RowContainer>
        ),
        getKey: (item) => item.id
    })
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isHistory = history.length > 0
    return (
        <S.HistoryContainer>
            {isHistory && (
                <S.HistoryRow>
                    <S.DescriptionSpan>История</S.DescriptionSpan>
                    <ButtonTransparent
                        colors={{
                            color: ThemeColors.getGrayColor(0.4),
                            hoverColor: ThemeColors.getGrayColor(0.6)
                        }}
                        clickHandler={clear}>
                        <S.ButtonSpan>Очистить</S.ButtonSpan>
                    </ButtonTransparent>
                </S.HistoryRow>
            )}
            {!isHistory && (
                <ContainerEmpty>
                    <EmptyMessage>Здесь появится история поиска</EmptyMessage>
                </ContainerEmpty>
            )}
            {history}
        </S.HistoryContainer>
    )
}
